export const nameConstants = {
    Patient : "Participant",
    
}
export const tgrDirBase = "C:\\GSD\\";
export const tmpFileBase = tgrDirBase + "Temp\\";
export const tmpFileName = tmpFileBase + "thud_log.csv";